export default __webpack_public_path__ + "static/media/section3-step2.02ed5c6c.png";